import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\ItemsExportController::__invoke
* @see app/Http/Controllers/Item/ItemsExportController.php
* @route '/api/item/items-export'
*/
const ItemsExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ItemsExportController.url(options),
    method: 'post',
})

ItemsExportController.definition = {
    methods: ["post"],
    url: '/api/item/items-export',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Item\ItemsExportController::__invoke
* @see app/Http/Controllers/Item/ItemsExportController.php
* @route '/api/item/items-export'
*/
ItemsExportController.url = (options?: RouteQueryOptions) => {
    return ItemsExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\ItemsExportController::__invoke
* @see app/Http/Controllers/Item/ItemsExportController.php
* @route '/api/item/items-export'
*/
ItemsExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ItemsExportController.url(options),
    method: 'post',
})

export default ItemsExportController